import { render, staticRenderFns } from "./ConvenioDocumentos.vue?vue&type=template&id=559ba1b6&"
import script from "./ConvenioDocumentos.vue?vue&type=script&lang=js&"
export * from "./ConvenioDocumentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports